import { useState, useEffect, useRef } from "react";
import TableResultsComponent from "./TableResults";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { trackEvent, KEYWORD_SEARCH } from "../utils/googleAnalytics";
const Keyword = ({ token }) => {
  const [category, setCategory] = useState("");
  const [modelCategory, setModelCategory] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [submittedSearchTerm, setSubmittedSearchTerm] = useState("");
  const [path, setPath] = useState("/keyword/search");
  const categoryRef = useRef(category);
  const [key, setKey] = useState(0);
  const [isFiltersExpanded, setIsFiltersExpanded] = useState(true);
  const [isResultsExpanded, setIsResultsExpanded] = useState(true);

  const handleSubmit = async (e) => {
    trackEvent(KEYWORD_SEARCH, "Keyword Search Page");
    e.preventDefault();
    if (searchTerm !== submittedSearchTerm) {
      let paramName;
      switch (categoryRef.current) {
        case "PROJECT NAME":
          paramName = "model_name";
          break;
        case "MODEL TYPE":
          paramName = "standardized_model_type";
          break;
        case "HUC":
          paramName = "huc_code";
          break;
        case "EVENT":
          paramName = "event";
          break;
        case "DESCRIPTION":
          paramName = "model_description";
          break;
        case "CATEGORY":
          paramName = "model_category";
          break;
        default:
          paramName = "model_name";
      }

      let payload;
      if (paramName === "model_category") {
        payload = {
          key: paramName,
          value: searchTerm.trim(),
          model_category: modelCategory || "", // will be "Alternative Analysis Model" by default when top category === 'CATEGORY'
        };
      } else {
        payload = {
          key: paramName,
          value: searchTerm.trim(),
        };
      }

      if (paramName === "event") {
        setSubmittedSearchTerm(searchTerm);
        setPath("/event/search");
      } else {
        // setSubmittedSearchTerm({ key: paramName, value: searchTerm })
        setSubmittedSearchTerm(payload);
        setPath("/keyword/search");
      }
      setKey((prevKey) => prevKey + 1);
      setIsFiltersExpanded(false);
      setIsResultsExpanded(true);
    }
  };

  useEffect(() => {
    if (category) {
      categoryRef.current = category;
      setSearchTerm("");
      setSubmittedSearchTerm("");
      setKey(0);
      if (category === "CATEGORY") {
        setModelCategory("Alternative Analysis Model");
      } else {
        setModelCategory("");
      }
    }
  }, [category]);

  const toggleFiltersSection = (e) => {
    e.stopPropagation();
    setIsFiltersExpanded(!isFiltersExpanded);
  };

  const toggleResultsSection = (e) => {
    e.stopPropagation();
    setIsResultsExpanded(!isResultsExpanded);
  };

  return (
    <div className="search-container-1">
      {/* Filters Card */}
      <div className="content-card global-content-card">
        <button
          type="button"
          className="card-header"
          onClick={toggleFiltersSection}
          aria-expanded={isFiltersExpanded}
          aria-controls="filters-section"
          aria-label={isFiltersExpanded ? "Collapse filters" : "Expand filters"}
        >
          <span className="card-title">Keyword Search</span>
          <span className="accordion-controls" aria-hidden="true">
            <span
              className={`toggle-btn ${
                isFiltersExpanded ? "expanded" : "collapsed"
              }`}
            >
              {isFiltersExpanded ? (
                <FaChevronUp className="up-rotate" />
              ) : (
                <FaChevronDown className="down-rotate" />
              )}
            </span>
          </span>
        </button>
        <div
          id="filters-section"
          className={`card-body ${
            isFiltersExpanded ? "expanded" : "collapsed"
          }`}
        >
          {/* Step 1 */}
          <div className="step">
            <div className="step-container">
              <p className="step-text">
                Select a category from the menu below.
              </p>
            </div>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="keyword-dropdown"
            >
              <option value="" disabled>
                Select an item from the menu
              </option>
              <option value="PROJECT NAME">Project Name</option>
              <option value="MODEL TYPE">Model Type</option>
              <option value="HUC">HUC</option>
              <option value="EVENT">Event</option>
              <option value="DESCRIPTION">Description</option>
              <option value="CATEGORY">Category</option>
            </select>
          </div>

          {/* Step 2 */}
          <div className="step">
            <div className="step-container">
              <p className="step-text">
                Enter a keyword into the search box below, and submit your
                inquiry.
              </p>
            </div>
            <div className="keyword-search-container">
              <form onSubmit={handleSubmit}>
                {/* Show modelCategory dropdown when any top category is selected */}
                {category === "CATEGORY" && (
                  <select
                    value={modelCategory}
                    onChange={(e) => setModelCategory(e.target.value)}
                    className="keyword-dropdown"
                    style={{ marginBottom: "10px" }}
                  >
                    <option value="" disabled>
                      Select Category
                    </option>
                    <option value="Alternative Analysis Model">
                      Alternative Analysis Model
                    </option>
                    <option value="Baseline Model">Baseline Model</option>
                    <option value="Other">Other</option>
                  </select>
                )}
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Type in your search and press Enter..."
                  className="keyword-search-input"
                />
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Results Card */}
      {submittedSearchTerm && (
        <div className="content-card">
          <button
            type="button"
            className="card-header"
            onClick={toggleResultsSection}
            aria-expanded={isResultsExpanded}
            aria-controls="results-section"
            aria-label={
              isResultsExpanded ? "Collapse results" : "Expand results"
            }
          >
            <span className="card-title">Results</span>
            <span className="accordion-controls" aria-hidden="true">
              <span
                className={`toggle-btn ${
                  isResultsExpanded ? "expanded" : "collapsed"
                }`}
              >
                {isResultsExpanded ? (
                  <FaChevronUp className="up-rotate" />
                ) : (
                  <FaChevronDown className="down-rotate" />
                )}
              </span>
            </span>
          </button>
          <div
            id="results-section"
            className={`card-body ${
              isResultsExpanded ? "expanded" : "collapsed"
            }`}
          >
            <TableResultsComponent
              key={key}
              submittedSearchTerm={submittedSearchTerm}
              path={path}
              ssp={true}
              token={token}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Keyword;
